import store from '@/store'
export function userRoot(){
    if(window.localStorage.getItem('AndroidToken')){
        const userRoot = store.state.user.inspectionRoles;
        const arr = userRoot.split(",");
        var flag = false
        arr.forEach((item)=>{
            if(item == 1){
                flag = true
            }
        }) 
    } 
    return flag
}
